"use strict";
/**
 * Created by Ning Jiang on 8/9/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeforeSpinStopPresentationController = void 0;
const BaseController_1 = require("../base/BaseController");
const gsap_1 = require("gsap");
class BeforeSpinStopPresentationController extends BaseController_1.BaseController {
    constructor(index, name, tweakEnabled, betWinMode) {
        super(tweakEnabled, name, betWinMode);
        this._isPlaying = false;
        this._isAborted = false;
        this._index = index;
        this.addEventListeners();
    }
    addEventListeners() {
        if (this.addFeatureEventHandlers) {
            this.addFeatureEventHandlers();
        }
    }
    reset() {
        this._gameData = null;
        this._isPlaying = false; // not really need :(.
        this._isAborted = false;
        if (this.resetFeature) {
            this.resetFeature();
        }
    }
    tryStartPresentation(data) {
        if (this.parseFeatureTriggered(data)) {
            this._isPlaying = true;
            this._timeline = new gsap_1.TimelineLite({ onComplete: () => this.finish() });
            this.startPresentation(this._timeline);
            return this.getSpinStopDelay(data);
        }
        return 0;
    }
    finish() {
        this._isPlaying = false;
        this.stopPresentation(this._isAborted);
    }
    abort(stopData) {
        if (this._isPlaying) {
            this._isPlaying = false;
            this._isAborted = true;
            this._timeline.progress(1);
        }
    }
}
exports.BeforeSpinStopPresentationController = BeforeSpinStopPresentationController;
//# sourceMappingURL=BeforeSpinStopPresentationController.js.map